import React from 'react';
import { CtaButton } from './CtaButton';
import { priceRows } from '../data/content';
export function Offer() {
  return <section id="offerta" className="w-full bg-cream-200 px-4 py-20 scroll-mt-12" data-id="element-86" data-mp="17xuswfmwwmsb">
      <div className="mx-auto max-w-md" data-id="element-87" data-mp="1mnsc0h5ziman">
        <h2 className="text-center font-display text-[26px] font-black leading-tight text-ink sm:text-[30px]" data-id="element-88" data-mp="1mpljfyof9ajp">
          <span aria-hidden="true" data-id="element-89" data-mp="1hqs4s2xefdhy">🏆</span> Offerta Speciale di Lancio
        </h2>

        <div className="mt-8 overflow-hidden rounded-2xl border border-brand/30 bg-white shadow-lift" data-id="element-90" data-mp="tz3fkvfvj558">
          <p className="bg-brand py-2 text-center font-sans text-[10px] font-bold uppercase tracking-[0.24em] text-white" data-id="element-91" data-mp="p1uzr1i77d75">
            Solo per i primi 200 iscritti
          </p>

          <div className="p-7" data-id="element-92" data-mp="ywd5sdb37ku4">
            <dl className="space-y-3" data-id="element-93" data-mp="z0anqvlxi6cf">
              {priceRows.map(row => <div key={row.label} className="flex items-baseline justify-between gap-4 border-b border-dashed border-cream-300 pb-3" data-id="element-94" data-mp="2feano6krxvzo">
                  <dt className="font-sans text-[12px] text-ink-soft" data-id="element-95" data-mp="pjz2nspjxdxq">{row.label}</dt>
                  <dd className="font-sans text-[12px] font-semibold text-ink-muted line-through" data-id="element-96" data-mp="uhqt0iajsrzt">
                    {row.value}
                  </dd>
                </div>)}
              <div className="flex items-baseline justify-between gap-4 pt-1" data-id="element-97" data-mp="13ip059ga9fmm">
                <dt className="font-sans text-[11px] font-bold uppercase tracking-[0.16em] text-ink" data-id="element-98" data-mp="6uioi2ky1myu">
                  Valore totale
                </dt>
                <dd className="font-sans text-[13px] font-bold text-ink-muted line-through" data-id="element-99" data-mp="bqpsvqxoyqeo">
                  €257
                </dd>
              </div>
            </dl>

            <div className="mt-7 text-center" data-id="element-100" data-mp="kmp4noo3jtya">
              <p className="font-sans text-[10px] font-bold uppercase tracking-[0.24em] text-brand" data-id="element-101" data-mp="3k8vrqk1p0e9b">
                Oggi lo paghi
              </p>
              <p className="mt-1 font-display text-[56px] font-black leading-none text-ink" data-id="element-102" data-mp="3o8o3t6qap2jf">€19</p>
              <p className="mt-2 font-sans text-[11px] text-ink-muted" data-id="element-103" data-mp="ve61c94ytnsr">
                Pagamento unico. Nessun abbonamento.
              </p>
            </div>

            <CtaButton className="mt-7 w-full" data-id="element-104" data-mp="1561zfk71xdwz">Ottieni il pacchetto Scienze Pronta™</CtaButton>

            <p className="mt-4 text-center font-sans text-[10.5px] leading-relaxed text-ink-muted" data-id="element-105" data-mp="105xixu658j6r">
              Pagamento sicuro con carta, PayPal o Carta del Docente. Download immediato dopo
              l&apos;acquisto.
            </p>
          </div>
        </div>
      </div>
    </section>;
}